import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { Selector } from 'components/Selector/Selector';
import { CreditsFilterOptionsContainer } from '../../filters/CreditsFilterOptionsContainer';
import { CreditsRangeLabel } from './CreditsRangeLabel';
import { creditsLabels } from '../../filters/filters.messages';
import { creditsRangeShape } from '../../filters/filters.helpers';

export class CreditsFilter extends Component {
  constructor(props) {
    super(props);

    this.handleOnClear = this.handleOnClear.bind(this);
    this.handleOnDone = this.handleOnDone.bind(this);
    this.handleToggleExpanded = this.handleToggleExpanded.bind(this);
  }

  handleOnClear() {
    const { onClear, onSetIsEditing } = this.props;

    onClear();
    onSetIsEditing(false);
  }

  handleOnDone() {
    const { isOutOfSync, onSyncFilter, onSetIsEditing } = this.props;

    if (isOutOfSync) {
      onSyncFilter();
    }
    onSetIsEditing(false);
  }

  handleToggleExpanded() {
    const { isEditing, onSetIsEditing } = this.props;

    onSetIsEditing(!isEditing);
  }

  render() {
    const { isMobile, isSelected, isEditing, creditsRange } = this.props;

    return (
      <Selector isMobile={isMobile} isSelected={isSelected} isOpen={isEditing} onToggle={this.handleToggleExpanded}>
        {({ Controls, DisclosureArrow, Panel, Selection }) => (
          <div className="unified-filters__filter">
            <Selection>
              {isSelected ? (
                <CreditsRangeLabel creditsRange={creditsRange} />
              ) : (
                <LocalizableMessage message={creditsLabels.default} />
              )}
              <DisclosureArrow />
            </Selection>
            <Panel onClose={this.handleOnDone}>
              <CreditsFilterOptionsContainer />
              <Controls disableClearControl={!isSelected} onClear={this.handleOnClear} onDone={this.handleOnDone} />
            </Panel>
          </div>
        )}
      </Selector>
    );
  }
}

CreditsFilter.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  onSyncFilter: PropTypes.func.isRequired,
  isOutOfSync: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
  creditsRange: creditsRangeShape,
};
